module.exports = __webpack_public_path__ + "img/1522530259.4678990d.jpg";